module.exports = __webpack_public_path__ + "assets/app/img/right-caret.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/images/right-caret.png
// module id = xHGE
// module chunks = 1